<template>
  <span>
    <v-btn icon @click="handleShowForm" v-if="groupedExecutedServices.length > 0">
      Add
    </v-btn>

    <v-dialog v-model="showModal" max-width="800" persistent>
      <v-card v-if="showModal">
        <v-card-title class="headline">Add case to invoice</v-card-title>

        <v-card-text>
          <v-form v-model="isValid" ref="form">
            <div v-for="executedService in groupedExecutedServices">
              <v-layout>
                <v-flex xs1 align-self-center>
                  <service-as-badge :service-id="executedService.serviceId"/>
                </v-flex>
                <v-flex xs1 align-self-center>
                  {{executedService.qty}}
                </v-flex>
                <v-flex xs1>
                  <modal-json-view :json-data="executedService"/>
                </v-flex>
              </v-layout>
            </div>
          </v-form>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="handleHideForm">Cancel</v-btn>
          <v-btn @click="handleFormSubmit"
                 :disabled="!isSubmitEnabled"
                 :loading="requestInProgress">
            Add
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </span>
</template>

<script>
  import {mapActions} from "vuex";
  import _ from 'lodash';
  import {notificationService} from "../../../application";
  import ServiceAsBadge from '../../Ui/mcc/ServiceAsBadge'
  import ModalJsonView from "../../Ui/ModalJsonView";

  function getDefaultFormData() {
    return {}
  }

  export default {
    name: 'attach-logs-to-invoice-form',
    components: {
      ServiceAsBadge,
      ModalJsonView
    },
    props: {
      invoiceId: {
        type: Number,
        required: true
      },
      affectedServices: {
        type: Object,
        required: true
      },
      log: {
        type: Array,
        required: true
      }
    },
    data() {
      return {
        form: getDefaultFormData(),
        showModal: false,
        isValid: false,
        requestInProgress: false,
      }
    },
    watch: {
      showModal() {
        if (!this.showModal) {
          this.resetForm()
        }
      }
    },
    computed: {
      isSubmitEnabled() {
        return this.isValid
      },
      affectedLogIds() {
        return this.affectedServices.list
          .map(it => it.affectedLogRecordIds)
          .reduce((acc, item) => {
            acc.push(...item);
            return acc
          }, [])
      },
      affectedExecutedLogs() {
        return this.log
          .filter(it => {
            let notAttachedToInvoice = it.metadata && !it.metadata.invoiceInfo;
            return _.includes(this.affectedLogIds, it.id) && it.event === 'ChangeExecuted' && notAttachedToInvoice
          });
      },
      groupedExecutedServices() {
        let services = {};

        for (let logItem of this.affectedExecutedLogs) {
          let service = services[logItem.serviceId];
          if (!service) {
            services[logItem.serviceId] = service = {
              serviceId: logItem.serviceId,
              qty: 0,
              logs: []
            }
          }

          service.qty += logItem.quantityChange;
          service.logs.push(logItem)
        }

        return _.values(services)
      }
    },
    methods: {
      ...mapActions({
        attachLogsToInvoice: 'invoiceAttachLogsToInvoice',
      }),
      handleShowForm() {
        this.showModal = true
      },
      handleHideForm() {
        this.showModal = false
      },
      handleFormSubmit() {
        if (!this.$refs.form.validate()) {
          return
        }

        let affectedExecutedLogsIds = this.affectedExecutedLogs
          .map(it => it.id);

        const request = {
          invoiceId: this.invoiceId,
          logIds: affectedExecutedLogsIds,
          affectedCaseId: this.log[0].caseId
        };

        this.requestInProgress = true;

        this
          .attachLogsToInvoice(request)
          .then(() => {
            notificationService.info('Operation success');
            this.resetForm();
            this.requestInProgress = false;
            this.showModal = false
          })
          .catch(e => {
            this.requestInProgress = false;
            notificationService.error('Operation failed');
            throw e
          })
      },
      resetForm() {
        this.form = getDefaultFormData(this.caseInfo)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/analytics/invoices/AttachLogsToInvoiceForm.vue